import { render, staticRenderFns } from "./account-help-and-support.vue?vue&type=template&id=2c1f3d88&"
import script from "./account-help-and-support.vue?vue&type=script&lang=js&"
export * from "./account-help-and-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports